(() => {
  const STORAGE_KEY = "nailsamiBridalServiceTray";

  function readTray() {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  }

  function writeTray(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch {
      /* The tray still works for the current page when storage is unavailable. */
    }
  }

  function initialise(page) {
    if (page.dataset.weddingInitialised === "true") return;
    page.dataset.weddingInitialised = "true";
    document.body.classList.add("wn-page-active");

    const trayCount = page.querySelector("[data-tray-count]");
    const trayButtons = [...page.querySelectorAll("[data-tray-button]")];
    let tray = readTray();

    const syncTray = () => {
      trayButtons.forEach((button) => {
        const selected = tray.includes(button.dataset.productHandle);
        button.classList.toggle("is-selected", selected);
        button.textContent = selected ? "Saved ✓" : "Save to service tray";
        button.setAttribute("aria-pressed", String(selected));
      });
      if (trayCount) trayCount.textContent = String(tray.length);
      writeTray(tray);
    };

    trayButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const handle = button.dataset.productHandle;
        tray = tray.includes(handle) ? tray.filter((item) => item !== handle) : [...tray, handle];
        syncTray();
      });
    });
    syncTray();

    const gelCards = [...page.querySelectorAll("[data-gel-card]")];
    const gelResultCount = page.querySelector("[data-gel-result-count]");
    page.querySelectorAll("[data-colour-filter]").forEach((button) => {
      button.addEventListener("click", () => {
        const filter = button.dataset.colourFilter;
        page.querySelectorAll("[data-colour-filter]").forEach((item) => {
          const active = item === button;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", String(active));
        });
        let visible = 0;
        gelCards.forEach((card) => {
          const matches = filter === "all" || card.dataset.colours.split(/\s+/).includes(filter);
          card.classList.toggle("wn-hidden", !matches);
          if (matches) visible += 1;
        });
        if (gelResultCount) gelResultCount.textContent = String(visible);
      });
    });

    const accessoryCards = [...page.querySelectorAll("[data-accessory-card]")];
    const accessoryResultCount = page.querySelector("[data-accessory-result-count]");
    page.querySelectorAll("[data-accessory-filter]").forEach((button) => {
      button.addEventListener("click", () => {
        const filter = button.dataset.accessoryFilter;
        page.querySelectorAll("[data-accessory-filter]").forEach((item) => {
          const active = item === button;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", String(active));
        });
        let visible = 0;
        accessoryCards.forEach((card) => {
          const matches = filter === "all" || card.dataset.category === filter;
          card.classList.toggle("wn-hidden", !matches);
          if (matches) visible += 1;
        });
        if (accessoryResultCount) accessoryResultCount.textContent = String(visible);
      });
    });
  }

  const boot = () => document.querySelectorAll("[data-wedding-page]").forEach(initialise);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
